import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DateRangePickerComponent } from './date-range-picker.component';
import { MaterialComponentsModule } from '../../material.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    DateRangePickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialComponentsModule
  ],
  exports: [
    DateRangePickerComponent
  ]
})
export class DateRangePickerModule { }
